
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      import logo from "../assets/mitsulift-logo-512.png";
export default {
  mounted: function () {
    var self = this;
    var app = self.$app;
    var $$ = self.$dom7; // Loading flag

    var allowInfinite = true; // Attach 'infinite' event handler
    //console.log($$('.news-infinite-scroll-content'));

    $$('.news-infinite-scroll-content').on('infinite', function () {
      // Exit, if loading in progress
      if (!allowInfinite) return; // Set loading flag

      allowInfinite = false; //console.log("Infinite");

      self.loadArticles(function () {
        // Reset loading flag
        allowInfinite = true;
      });
    });
    $$('.news-ptr-content').on('ptr:refresh', function (e) {
      //console.log("ptr:refresh");
      self.$setState({
        nextPage: {
          href: Url.to("guest/articles?per-page=3")
        },
        news: []
      }, function () {});
      self.$tick(function () {
        self.loadArticles(function () {
          // Reset loading flag
          app.ptr.done('.news-ptr-content');
          app.infiniteScroll.create('.news-infinite-scroll-content');
        });
      });
    });
  },
  beforeMount: function () {
    var self = this;
    var app = self.$app;
    var $$ = self.$dom7; //Get articles
    // $$("#view-home").once("tab:show", function () {

    self.loadArticles(function () {}); // });
    // $$("#view-home").on("tab:show", function () {
    //     console.log("SHOWN")
    //    if(window.newsRequireRefresh){
    //        window.newsRequireRefresh = false;
    //        $$("#view-home").off("tab:show");
    //        self.$router.refreshPage()
    //    }
    // });
  },
  methods: {
    openLoginScreen: function () {
      var self = this;
      var app = self.$app;
      var $$ = self.$dom7;
      app.loginScreen.open("#my-login-screen", true);
    },
    openGetInTouchScreen: function () {
      var self = this;
      var app = self.$app;
      var $$ = self.$dom7;
      app.loginScreen.open("#get-in-touch-screen", true);
    },
    readArticle: function (id) {
      //console.log(id);
      var self = this;
      var app = self.$app;
      var router = self.$router;
      var article = {};
      self.news.forEach(function (art) {
        if (art.id === id) {
          article = art;
          return false;
        }
      });
      router.navigate("/article/", {
        context: {
          article: article
        }
      });
    },
    loadArticles: function (callback) {
      var self = this;
      var app = self.$app;
      var $$ = self.$dom7;

      if (self.nextPage) {
        app.request({
          url: self.nextPage['href'],
          preloader: false,
          progress: true,
          success: function (data, status, xhr) {
            //console.log("News", data, data['links']['next']);
            self.$setState({
              news: self.news.concat(data['items']),
              nextPage: data['links']['next']
            }, function () {
              if (!self.nextPage) {
                app.infiniteScroll.destroy('.news-infinite-scroll-content');
                $$('.news-infinite-scroll-content .infinite-scroll-preloader').remove();
              } //autoplay videos
              // console.log(">>>>",$$("video:not(.loaded)"))


              $$("video:not(.loaded)").forEach(video => {
                // console.log(video);
                video.muted = true;
                video.load();
                video.play();
                $$(video).addClass("loaded");
              });
            });
            self.$tick(function () {
              callback();
            });
          }
        });
      } else {
        app.infiniteScroll.destroy('.news-infinite-scroll-content');
        $$('.news-infinite-scroll-content .infinite-scroll-preloader').remove();
      }
    }
  },
  on: {
    pageBeforeIn: function (a, b, c) {
      var self = this;
      self.$setState({}, function () {});
    }
  },
  data: function () {
    var self = this;
    var app = self.$app;
    var $$ = self.$dom7;
    console.log(app.device.os.toLowerCase());
    return {
      nextPage: {
        href: Url.to("guest/articles?per-page=3")
      },
      news: [],
      logo: logo,
      platform: app.device.os.toLowerCase()
    };
  },
  id: 'daf4d8ff9e',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '\n    <div class="page navbar-extra-large with-navbar-fixed no-toolbar" data-name="guest-news">\n        <!-- Top Navbar -->\n        <div class="navbars navbar-hidden navbar-large-hidden"></div>\n\n        <div class="toolbar toolbar-bottom tabbar-labels no-overflow">\n            <div class="toolbar-inner">\n                <a href="#" class="link tab-link-active">\n                    <i class="icon f7-icons">house</i>\n                    <span class="tabbar-label">Home</span>\n                </a>\n                <a href="#" class="link tab-link tab-link-raised" @click="openGetInTouchScreen">\n                    <i class="icon material-icons">message</i>\n                    <span class="tabbar-label">Get In Touch</span>\n                </a>\n                <a href="#" class="link" @click="openLoginScreen">\n                    <i class="icon f7-icons">my_mitsu</i>\n                    <span class="tabbar-label">My Mitsu</span>\n                </a>\n                <!--                <a href="#view-news" class="tab-link">-->\n                <!--                    <i class="icon f7-icons">compass</i>-->\n                <!--                    <span class="tabbar-label">Discover</span>-->\n                <!--                </a>-->\n                <!--                <a href="#view-notifications" class="tab-link">-->\n                <!--                    <i class="icon f7-icons">-->\n                <!--                        bell-->\n                <!--                        <span id="notifications-count" class="badge color-red display-none"></span>-->\n                <!--                    </i>-->\n                <!--                    <span class="tabbar-label">Notifications</span>-->\n                <!--                </a>-->\n                <!--                <a href="#view-account" class="tab-link">-->\n                <!--                    <i class="icon f7-icons">person</i>-->\n                <!--                    <span class="tabbar-label">Account</span>-->\n                <!--                </a>-->\n            </div>\n        </div>\n        <div class="page-content news-infinite-scroll-content infinite-scroll-content\n        news-ptr-content ptr-content">\n            <div class="navbar navbar-large navbar-extra-large navbar-fixed">\n                <div class="navbar-bg"></div>\n                <div class="navbar-inner">\n                    <div class="left"></div>\n                    <div class="title sliding"></div>\n                    <div class="title-large">\n                        <div class="title-large-text">hello,\n                            <div class="right" style="top:0">\n\n                            </div>\n                            <div class="right display-none" style="top:0">\n                                <a class="link icon-only no-margin-left text-color-gray external" target="_system" href="https://www.facebook.com/mitsuliftgroup">\n                                    <i class="icon f7-icons">logo_facebook</i>\n                                </a>\n                                <a class="link icon-only no-margin-left text-color-gray external" target="_system" href="https://www.linkedin.com/company/mitsulift-group/">\n                                    <i class="icon f7-icons">logo_linkedin</i>\n                                </a>\n                                <a class="link icon-only no-margin-left text-color-gray external" target="_system" href="https://www.instagram.com/mitsuliftgroup/">\n                                    <i class="icon f7-icons">logo_instagram</i>\n                                </a>\n                            </div>\n                            <div class="subtitle-text"></div>\n                        </div>\n\n                    </div>\n                </div>\n            </div>\n            <div class="ptr-preloader">\n                <div class="preloader"></div>\n                <div class="ptr-arrow"></div>\n            </div>\n            ';
      r += Template7Helpers.each.call(ctx_1, ctx_1.news, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n            <div class="block article-block no-hairlines">\n                <bdi class="article-category" style="font-size: 13px;color: rgb(153,153,153)">';
          r += c(ctx_2.category, ctx_2);
          r += '</bdi>\n                <bdi class="article-title">';
          r += c(ctx_2.title, ctx_2);
          r += '</bdi>\n                <bdi class="article-subtitle">';
          r += c(ctx_2.subtitle, ctx_2);
          r += '</bdi>\n                ';
          r += Template7Helpers.if.call(ctx_2, ctx_2.video_preview, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                <video  @click="readArticle(';
              r += c(ctx_3.id, ctx_3);
              r += ')" muted="muted" autoplay="autoplay" playsinline preload="auto" width="100%" loop="loop"\n                       data-src="';
              r += c(ctx_3.video_preview, ctx_3);
              r += '" id="video-preview-';
              r += c(ctx_3.id, ctx_3);
              r += '" poster="';
              r += c(ctx_3.image_thumb_1024_url, ctx_3);
              r += '"   oncanplay="this.muted=true">\n                    <source src="';
              r += c(ctx_3.video_preview, ctx_3);
              r += '" type="video/mp4">\n                </video>\n                ';
              return r;
            },
            inverse: function (ctx_3, data_3) {
              var r = '';
              r += '\n                <div  @click="readArticle(';
              r += c(ctx_3.id, ctx_3);
              r += ')" class="article-image" style="background-image: url(';
              r += c(ctx_3.image_thumb_1024_url, ctx_3);
              r += ')"></div>\n                ';
              return r;
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                <div class="article-footer">\n                    <a @click="readArticle(';
          r += c(ctx_2.id, ctx_2);
          r += ')" data-id="';
          r += c(ctx_2.id, ctx_2);
          r += '" href="#">\n                        Find out more\n                        <i class="icon f7-icons">chevron_right</i>\n                    </a>\n                </div>\n            </div>\n            ';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += '\n            ';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n            <div class="preloader infinite-scroll-preloader"></div>\n        </div>\n    </div>\n';
      return r;
    }(this);
  },

  styleScoped: false
};
    